module.exports = __webpack_public_path__ + "img/empty.5b38a7a8.png";